import React from 'react';
import { Button } from 'antd';
import Icon from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { updateConfig } from '@store/serviceIntegrations/integrationForm/actions';
import { setMode, setEnablePartnerModalVisibility } from '@store/serviceIntegrations/base/actions';
import { SERVICE_INTEGRATION_MODE_FORM } from '@utils/constants';
import { PartnerCardWrapper, PartnerLogoWrapper } from '../styled';

interface IProps {
  partner: {
    partnerId: number;
    name: string;
    logo: any;
    featureFlagSelector: any;
  };
}

function PartnerCard({ partner }: IProps) {
  const dispatch = useDispatch();
  const { logo: Logo, partnerId, name, featureFlagSelector } = partner;

  const featureFlag = useSelector(featureFlagSelector) ?? false;

  const addService = () => {
    dispatch(
      updateConfig({
        partnerId,
        partnerName: name,
      }),
    );
    dispatch(setMode(SERVICE_INTEGRATION_MODE_FORM));
  };

  const askToEnableService = () => {
    dispatch(setEnablePartnerModalVisibility(true));
  };

  return (
    <PartnerCardWrapper>
      <PartnerLogoWrapper>
        <Icon component={Logo} style={{ fontSize: '100px' }} />
      </PartnerLogoWrapper>
      <Button onClick={featureFlag ? addService : askToEnableService}>Add Service</Button>
    </PartnerCardWrapper>
  );
}

export default PartnerCard;
